<section class="form-inscriptions-offre-cours">
  <template v-if="formIdsInError.length > 0">
    <m-toast
      :open="true"
      :state="MToastState.Error"
      :position="MToastPosition.TopCenter"
    >
      <transition
        name="fade-fast"
        mode="out-in"
      >
        <span :key="formErrorMessage">
          {{ formErrorMessage }}
        </span>
      </transition>
    </m-toast>
  </template>
  <template v-else-if="formIdsStateChanged.length > 0">
    <m-toast
      :open="true"
      :state="MToastState.Warning"
      :position="MToastPosition.TopCenter"
    >
      <transition
        name="fade-fast"
        mode="out-in"
      >
        <span :key="formStateChangeMessage">
          {{ formStateChangeMessage }}
        </span>
      </transition>
    </m-toast>
  </template>
  <transition
    name="fade-fast"
    mode="out-in"
  >
    <template v-if="isFormInscriptionsOffreCoursLoadingStateActive">
      <div
        class="form-inscriptions-offre-cours--loading"
        key="form-inscriptions-offre-cours--loading"
      >
        <m-spinner
          title="true"
          description="true"
        />
      </div>
    </template>
    <template v-else-if="!inscriptionsOffreCours || inscriptionsOffreCours.length === 0">
      <div
        class="form-inscriptions-offre-cours--error"
        key="form-inscriptions-offre-cours--error"
      >
        <m-message :state="MMessageState.Error">
          <span v-html="$i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.message.inscriptions_offre_cours_list_empty')" />
        </m-message>
      </div>
    </template>
    <template v-else>
      <m-form
        :form-group="formGroup"
        class="form-inscriptions-offre-cours__form"
        key="form-inscriptions-offre-cours__form"
        @submit="onFormSubmit"
      >
        <template v-if="dossierEtudiant && dossierEtudiant.statutInscription !== StatutInscription.INSCRIPTION_TERMINEE">
          <section class="form-inscriptions-offre-cours__form-controls">
            <m-button
              :type="MButtonType.Submit"
              :disabled="isSubmitButtonDisabled"
            >
              {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.button.submit') }}
            </m-button>
          </section>
        </template>
        <section class="form-inscriptions-offre-cours__form-inscriptions">
          <template v-for="inscriptionOffreCours in inscriptionsOffreCours">
            <inscription-offre-cours-panel
              :ref="REF_INSCRIPTION_OFFRE_COURS_PANEL"
              :inscription-offre-cours="inscriptionOffreCours"
            />
          </template>
        </section>
        <template v-if="dossierEtudiant && dossierEtudiant.statutInscription !== StatutInscription.INSCRIPTION_TERMINEE">
          <section class="form-inscriptions-offre-cours__form-controls">
            <m-button
              :type="MButtonType.Submit"
              :disabled="isSubmitButtonDisabled"
            >
              {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.button.submit') }}
            </m-button>
          </section>
        </template>
      </m-form>
    </template>
  </transition>
  <m-modal
    :open="isConfirmationDialogActive"
    :title="$i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.title')"
    :ref="REF_CONFIRMATION_DIALOG"
    @portal-after-close="afterCloseConfirmationDialog"
  >
    <div class="form-inscriptions-offre-cours__confirmation-dialog">
      <transition
        name="fade-fast"
        mode="out-in"
      >
        <template v-if="isSaveFormInscriptionsOffreCoursLoadingStateActive">
          <div
            class="form-inscriptions-offre-cours__confirmation-dialog--loading"
            key="form-inscriptions-offre-cours__confirmation-dialog--loading"
          >
            <m-spinner
              title="true"
              description="true"
            />
          </div>
        </template>
        <template v-else-if="isSaveFormInscriptionsOffreCoursErrorStateActive">
          <div
            class="form-inscriptions-offre-cours__confirmation-dialog--error"
            key="form-inscriptions-offre-cours__confirmation-dialog--error"
          >
            <m-message
              :skin="MMessageSkin.Page"
              :state="MMessageState.Error"
              :title="$i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.message.error.title')"
            />
          </div>
        </template>
        <template v-else-if="isSaveFormInscriptionsOffreCoursSuccessStateActive">
          <div
            class="form-inscriptions-offre-cours__confirmation-dialog--success"
            key="form-inscriptions-offre-cours__confirmation-dialog--success"
          >
            <m-message
              :skin="MMessageSkin.Page"
              :state="MMessageState.Success"
              :title="$i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.message.success.title')"
            />
          </div>
        </template>
        <template v-else>
          <div
            class="form-inscriptions-offre-cours__confirmation-dialog--overview"
            key="form-inscriptions-offre-cours__confirmation-dialog--overview"
          >
            <h4 class="form-inscriptions-offre-cours__confirmation-dialog--title">
              {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.title') }}
            </h4>
            <template v-for="inscriptionOffreCours in inscriptionsOffreCours">
              <div>
                <h6>
                  {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.inscription_offre_cours.title', inscriptionOffreCours) }}
                  {{ inscriptionOffreCours.titreCours }}
                </h6>
                <p>
                  <template v-if="hasInscriptionOffreCoursChanged(inscriptionOffreCours)">
                    <template v-for="inscriptionLieuExamen, index in inscriptionOffreCours.inscriptionsLieuExamen">
                      <template v-if="formIdsStateChanged.includes(inscriptionLieuExamen.id)">
                        <p>
                          <template v-if="inscriptionLieuExamen.horodateCampus || inscriptionLieuExamen.horodateHorsCampus">
                            <span v-html="$i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.inscription_lieu_examen.multiple_timestamp.type_examen', inscriptionLieuExamen)" />
                            <span v-html="generateConfirmationSituationLabel(inscriptionLieuExamen)" />
                            <ul>
                              <template v-if="inscriptionLieuExamen.horodateCampus">
                                <li>
                                  <template v-if="inscriptionLieuExamen.horodateHorsCampus">
                                    {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.inscription_lieu_examen.multiple_timestamp.timestamp_campus', inscriptionLieuExamen) }}
                                  </template>
                                  <template v-else>
                                    {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.inscription_lieu_examen.multiple_timestamp.timestamp_campus_sans_precision', inscriptionLieuExamen) }}
                                  </template>
                                </li>
                              </template>
                              <template v-if="inscriptionLieuExamen.horodateHorsCampus">
                                <li>
                                  <template v-if="inscriptionLieuExamen.horodateCampus">
                                    {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.inscription_lieu_examen.multiple_timestamp.timestamp_hors_campus', inscriptionLieuExamen) }}
                                  </template>
                                  <template v-else>
                                    {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.inscription_lieu_examen.multiple_timestamp.timestamp_hors_campus_sans_precision', inscriptionLieuExamen) }}
                                  </template>
                                </li>
                              </template>
                            </ul>
                          </template>
                          <template v-else>
                            <span v-html="$i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.inscription_lieu_examen.no_timestamp', inscriptionLieuExamen)" />
                            <span v-html="generateConfirmationSituationLabel(inscriptionLieuExamen)" />
                          </template>
                        </p>
                      </template>
                    </template>
                  </template>
                  <template v-else>
                    {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.content.inscription_offre_cours.no_change') }}
                  </template>
                </p>
              </div>
            </template>
          </div>
        </template>
      </transition>
    </div>
    <template #footer>
      <transition
        name="fade-fast"
        mode="out-in"
      >
        <template v-if="isSaveFormInscriptionsOffreCoursErrorStateActive || isSaveFormInscriptionsOffreCoursSuccessStateActive || isSaveFormInscriptionsOffreCoursLoadingStateActive">
          <m-button
            :skin="MButtonSkin.Secondary"
            @click="closeConfirmationDialog"
          >
            {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.button.close') }}
          </m-button>
        </template>
        <template v-else>
          <span>
            <m-button
              :skin="MButtonSkin.Secondary"
              @click="closeConfirmationDialog"
            >
              {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.button.cancel') }}
            </m-button>
            <m-button @click="updateInscriptionsLieuExamen">
              {{ $i18next.t('modules.inscription-lieu-examen.form.FormInscriptionOffreCours.confirmation_dialog.button.submit') }}
            </m-button>
          </span>
        </template>
      </transition>
    </template>
  </m-modal>
</section>